import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'
import { resolveKitchenFlowGate, type KitchenFlowGate } from '@/hooks/useKitchenFlowEnabled'

/**
 * Delivery riders (F-DLV-N1): backend env `FEATURE_RIDER_APP=1`, surfaced as
 * the server-injected `feature_rider_app` key on GET /settings. The rider
 * role, the Deliveries page and the dispatch controls render only when this
 * is exactly true; a missing key or failed fetch reads as off.
 *
 * Same gate semantics as the kitchen flow (a stale "off" being re-checked is
 * loading, not an answer) and the same shared `['settings','all']` cache.
 */
export function useRiderAppGate(): KitchenFlowGate {
  const { data, status, fetchStatus, refetch } = useQuery({
    queryKey: ['settings', 'all'],
    queryFn: () => apiClient.getAllSettings(),
    staleTime: Infinity,
  })
  const all = data?.data as Record<string, unknown> | undefined
  return {
    ...resolveKitchenFlowGate({ flag: all?.feature_rider_app, status, fetchStatus }),
    retry: () => void refetch(),
  }
}

export function useRiderAppEnabled(): boolean {
  return useRiderAppGate().enabled
}
